<template>
    <section v-if="hasPermissions(['Budgeting-Staffing-Scenario Read','Budgeting-Staffing-Scenario Write' ])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            {{ title_page }}
        </h1>
        <div class="view__description">
            <p class="view__description__text">
                This is a list of Staffing Scenarios. To modify an existing scenario, click the Detail icon or Description link. Make any changes and click Save.
            </p>
        </div>

        <div class="bar-container">
            <div class="bar-container__search-bar">
                <div class="input-field my-0" v-if="staffing_scenarios.length && hasPermissions(['Budgeting-Staffing-Scenario Read'])">
                    <i class="material-icons prefix iconInput">search</i>
                    <input id="icon_prefix" type="text" class="validate inputSearch" placeholder="Search" v-model="search">
                </div>
            </div>
            <div class="bar-container__options">
                <button class="modal__buttons__item w-auto px-3" v-html="'Mass Delete'" :class="{'disabled button__disabled' : !selected}" :disabled="!selected" @click="massive_modal_delete()"/>
                <button type="button" class="modal__buttons__item" v-html="`Duplicate this Record`" @click="openDuplicationModal()" :class="{'disabled button__disabled' : !selectedOne}" :disabled="!selectedOne" />
            </div>
            <div v-if="hasPermissions(['Budgeting-Staffing-Scenario Write'])" class="bar-container__cta">
                <span class="button__modal text-right">
                    <a href="/budgeting-staffing-scenario/create" class="d-inline-md-block">
                        {{ add_btn }}
                        <i class="prefix ml-1">
                            <img src="/assets/img/svg/add.svg" alt="date" style="width: 15px">
                        </i>
                    </a>
                </span>
            </div>
        </div>

        <div class="tab-content" v-show="staffing_scenarios.length && hasPermissions(['Budgeting-Staffing-Scenario Read'])">
            <div class="tab-pane fade active show" id="listation">
                <div class="row mb-0 no-gutters">
                    <div class="col-lg-12">
                        <v-card>
                            <DinamicTable
                                :headers="table_headers"
                                :items="staffing_scenarios"
                                :search="search"
                                :checkable="true"
                                :link="'/budgeting-staffing-scenario/update/'"
                                :updateable="true"
                                @emitToUpdate="modal_update($event)"
                                @emitLinkAction="emitLinkAction($event)"
                                ref="dinamic_table"
                            />
                        </v-card>
                    </div>
                </div>
            </div>
        </div>

        <DeletionModal 
            :single_object="single_object" 
            :global_index="global_index" 
            @objectDeletion="object_deletion($event)"
        />

        <DeletionMassiveModal
            @objectDeletion="massive_local_emition($event)"
        />

        <FormModal 
            :title="'New Staffing Scenario'"
            :breadcrumb="breadcrumb"
            :content_header="content_header"
            :rest_api="rest_api"
            :notifications="notifications"
            :notyf="notyf"
            :axios="axios"
            :array_options="array_options"
            :date="date"
            @unshiftObject="unshift_object($event)"
        />

        <UpdateModal 
            :title="'Staffing Scenario Update'"
            :breadcrumb="breadcrumb"
            :content_header="content_header"
            :rest_api="rest_api"
            :notifications="notifications"
            :notyf="notyf"
            :axios="axios"
            :single_object="single_object"
            :global_index="global_index"
            :array_options="array_options"
            @spliceObject="splice_object($event)"
        />

        <HelperModal :helps="helps"/>
        <DuplicationModal :breadcrumb="breadcrumb" title="Duplicate Scenario" :id="record_id_to_duplicate" @unshift_object="unshift_object"/>

        <WaitingModal/>
    </section>
    <div v-else>
        <UnauthorizedComponent :breadcrumb="breadcrumb"/>
    </div>
</template>

<script>
import axios                from    'axios';
import Breadcrumb           from    '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal         from    '@/components/WaitingModal'
import Resources            from    './resources'
import FormModal            from    './FormModal'
import UpdateModal          from    './UpdateModal'
import DeletionModal        from    '@/components/DeletionModal'
import DinamicTable         from    '@/components/DinamicTable'
import DeletionMassiveModal from    '@/components/DeletionMassiveModal'
import HelperModal          from    '@/components/HelperModal'
import UnauthorizedComponent from   '@/components/UnauthorizedComponent'
import 'vuetify/dist/vuetify.min.css'

import { Notyf }            from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
import DuplicationModal from '../StaffingScenariosV2/DuplicationModal.vue';
const notyf = new Notyf({
    duration: 8000,
});
export default {
    name: 'StaffingScenarios',

    components: {
      Breadcrumb,
      WaitingModal,
      DeletionModal,
      FormModal,
      UpdateModal,
      DinamicTable,
      DeletionMassiveModal,
      UnauthorizedComponent,
      HelperModal,
      DuplicationModal
    },

    data() {
        return {
            notyf,
            axios,
            user:               this.get_user(),
            title_page:         'Staffing Scenarios',
            content_header:     this.$store.state.headers,
            rest_api:           `staffing_scenarios`,
            notifications:      this.$store.state.form_notyf,
            table_headers:      Resources.table_headers,
            breadcrumb:         Resources.breadcrumb,
            add_btn:            'Add Staffing Scenario',
            single_select:      false,
            table_selection:    [],
            search:             '',
            global_index:       undefined,
            single_object:      {},
            staffing_scenarios:        [],
            array_options:      {},
            date:               '',
            select_ids:         [],
            helps:                  Resources.helps,
            record_id_to_duplicate: undefined,
        }
    },

    methods: {
        openDuplicationModal()
        {
            this.record_id_to_duplicate = this.staffing_scenarios.find(item => item.checked)?.id

            if(!this.record_id_to_duplicate)
            {
                notyf.error('You must select a record to duplicate')
                return false
            }

            window.$('#static-duplication').modal('show')
        },
        format_href(value)
        {

            return `<a href="#">${value}</a>`
        },

        unshift_object(new_object)
        {
            this.staffing_scenarios.unshift(new_object)
        },

        splice_object(splicing_object)
        {
            this.staffing_scenarios.splice(splicing_object.index, 1, splicing_object.single_object)
        },

        form_modal()
        {
            if(!this.user.has_facility){
                notyf.error('There is not exists a facility yet')
                return false
            }
            window.$('#static').modal('show')
        },

        modal_deletion(index)
        {
            this.global_index  = index
            this.single_object = this.staffing_scenarios[index]
            window.$('#static-deletion').modal('show')
        },

        modal_update(index)
        {
            this.global_index  = index
            this.single_object = this.staffing_scenarios[index]
            this.single_object.updated_date = this.date;

            if(this.single_object?.id)
            {
                window.location = `budgeting-staffing-scenario/update/${this.single_object.id}`
            }
        },

        fill_data(data)
         {
           this.staffing_scenarios = data.staffing_scenarios
            this.date = data.system_date;
        },

        trashing(index)
        {
            this.staffing_scenarios.splice(index, 1)
        },

        massive_modal_delete()
        {
            this.select_ids = this.staffing_scenarios.filter(item => item.checked).map(item => item.id)
            if(this.select_ids.length)
            {
                window.$('#static-deletion-massive').modal('show')
            }
        },

        async massive_local_emition()
        {
            let json_request = {
                ids:         this.select_ids,
            }

            let sendingMassive = await this.massive_delete(json_request)

            if(sendingMassive)
            {
                this.select_ids.forEach( item =>
                {
                    const index = this.staffing_scenarios.findIndex(value => value.id == item)
                    if(index > -1)
                    {
                        this.staffing_scenarios.splice(index, 1)
                    }
                })
                this.select_ids = []
            }
        },

        emitLinkAction(i)
        {
            const id = this.$refs.dinamic_table.display_items[i].decrypted_id
            this.$router.push(`standard-reports/staffing-scenario/budgeting-report/${id}`)
        }

    },
    async mounted() {
      if(this.hasPermissions(['Budgeting-Staffing-Scenario Read']))
        {
            await this.api_request()
        }
    },

    computed:
    {
        selected()
        {
            const bool = this.staffing_scenarios.filter(item => item.checked)
            return Boolean(bool.length)
        },

        selectedOne()
        {
            const bool = this.staffing_scenarios.filter(item => item.checked)

            if(bool.length === 1)
            {
                return true
            }
            else 
            {
                return false
            }
        }
    },
}
</script>
